import React from 'react';
import { useFormState } from 'react-final-form';
import { ReferenceInput, SelectInput } from 'react-admin';

const CountryInput = props => {
    const { values } = useFormState();
    const { defaultValue, disabled, ...rest } = props;

    return (
        <ReferenceInput
            variant="outlined"
            label="Country"
            source="countryId"
            reference="country"
            resource="country"
            fullWidth={true}
            style={{ width: '256px' }}
            {...(defaultValue ? { defaultValue } : {})}
            {...rest}
        >
            <SelectInput optionText="name" disabled={disabled} />
        </ReferenceInput>
    );
};

export default CountryInput;
